import React, { useEffect, useState } from "react";
import { List, Avatar, Button, Modal } from "antd";
import { connect } from "react-redux";
import { selectDataFromExecQuery } from "../../actions/funcional.group";

const EXEC_QUERY_NAME = {
    detentor: "detentor",
};

const ContributorsList = ({ selectDataFromExecQuery, dataFromExistGroup }) => {
    const { codigo } = dataFromExistGroup;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        debugger;
        if (codigo) {
            setLoading(true);
            (async () => {
                const response = await selectDataFromExecQuery({
                    query: EXEC_QUERY_NAME.detentor,
                    codigo: codigo,
                });

                if (response.result) {
                    if (Array.isArray(response.result)) {
                        setDataSource(response.result);
                    }
                }
                setLoading(false);
            })();
        }
    }, [codigo]);

    function handlePreviewImage(image) {
        setPreviewImage(image);
    }

    function handleCancelPreviewImage() {
        setPreviewImage(null);
    }

    return (
        <>
            <List
                header={<h3>Funcionários</h3>}
                loading={loading}
                itemLayout="horizontal"
                dataSource={dataSource}
                renderItem={(item) => (
                    <List.Item>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {item.foto_perfil ? (
                                <Button
                                    style={{ padding: 0 }}
                                    type="link"
                                    onClick={() => {
                                        handlePreviewImage(item.foto_perfil);
                                    }}
                                >
                                    <Avatar src={item.foto_perfil} />
                                </Button>
                            ) : (
                                <Avatar icon="user" />
                            )}
                            <span style={{ marginLeft: "6px" }}>{item.nome}</span>
                        </div>
                    </List.Item>
                )}
            />

            {previewImage && (
                <Modal visible footer={null} onCancel={handleCancelPreviewImage}>
                    <img alt="" style={{ width: "100%" }} src={previewImage} />
                </Modal>
            )}
        </>
    );
};

const mapDispatchToProps = {
    selectDataFromExecQuery,
};

export default connect(null, mapDispatchToProps)(ContributorsList);
